module.exports = __webpack_public_path__ + "static/logo.3c93b41c.svg";